module.exports = __webpack_public_path__ + "static/media/Cumming_3.cbe9bc95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/Cumming_3.jpg
// module id = 462
// module chunks = 0